import { useSnapshot } from "valtio";

import React, { lazy, useEffect } from "react";
import { useDispatch } from "react-redux";

import { CommentKeyboard } from "@components/OrderTaking/common/CommentKeyboard";
import { WorkflowDialog } from "@components/OrderTaking/Components/Dialogs/WorkflowDialog";
import OrderTakingScreen from "@components/OrderTaking/Screens/OrderTakingScreen";
import PrmOrderTakingScreen from "@components/OrderTaking/Screens/PrmOrderTakingScreen";

import { kioskStore } from "@pages/Kiosk/store";

import {
    ClearWorkflowItem,
    SelectProduct,
    setWorkflowData,
} from "../Store/feature";

const MenuFormulaSale = lazy(
    () => import("@components/OrderTaking/Components/Dialogs/MenuFormulaSale")
);

export function Screens(): JSX.Element {
    const dispatchStore = useDispatch();
    const { isPrm } = useSnapshot(kioskStore);
    useEffect(() => {
        return () => {
            dispatchStore(ClearWorkflowItem());
            dispatchStore(SelectProduct({}));
            dispatchStore(setWorkflowData([]));
        };
    }, []);

    return (
        <>
            {isPrm ? <PrmOrderTakingScreen /> : <OrderTakingScreen />}
            <MenuFormulaSale />
            <WorkflowDialog />
            <CommentKeyboard />
        </>
    );
}
